module.exports = __webpack_public_path__ + "img/CM-KT-24-Mazda-Modern.738c7d4e.jpg";